import { type Utm } from 'core/domain/Utm'
import { type HttpClientConfig, type HttpClientInterface } from 'core/infra/http/HttpClient'

import { type LoadOffer } from '../domain/LoadOffer'
import { mapApiToLoadOffer, type RawLoadOffer } from './loadOfferMapper'

type LoadRepositoryDependencies = {
  httpClient: HttpClientInterface
}

export class LoadOfferRepository {
  private httpClient: HttpClientInterface

  constructor({ httpClient }: LoadRepositoryDependencies) {
    this.httpClient = httpClient
  }

  async getLoadOfferByLoadId(id: string, config?: Partial<HttpClientConfig>): Promise<LoadOffer> {
    const endpoint = `/api/v2/loadboard/loads/${id}`
    const { data } = await this.httpClient.get<RawLoadOffer>(endpoint, config)
    return mapApiToLoadOffer(data)
  }

  async acceptLoadOffer({
    loadOfferUUID,
    offerUUID,
    utmParams,
    config,
  }: {
    loadOfferUUID: string
    offerUUID: string
    utmParams?: Utm
    config?: Partial<HttpClientConfig>
  }): Promise<void> {
    const endpoint = `/api/v2/loadboard/loads/${loadOfferUUID}/accept`
    const data = {
      channel: 'carrier',
      offer_id: offerUUID,
      ...utmParams,
    }
    await this.httpClient.post(endpoint, data, config)
  }
}
